// * Import lib
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { ThemeProvider, CssBaseline } from "@mui/material";
import ReactGA from "react-ga4";
import TagManager from "react-gtm-module";

// * Import custom components
import App from "./js/App.jsx";

// Import theme
import { darkTheme, lightTheme } from "./js/theme";

// Import store
import { store } from "./js/redux/store";

// * Import styling files
import "./index.scss";
import { useSelector } from "react-redux";
import { GA_ID, GTM_ID } from "./js/utils/config.js";

const getAppTheme = (appTheme) => {
  if (appTheme === "light") {
    return lightTheme;
  } else if (appTheme === "dark") {
    return darkTheme;
  } else {
    const isDarkMode = window.matchMedia(
      "(prefers-color-scheme: dark)"
    ).matches;
    return isDarkMode ? darkTheme : lightTheme;
  }
};

// Google Analytics Initlitalization
ReactGA.initialize([
  {
    trackingId: GA_ID["PROD"],
  },
]);

const tagManagerArgs = {
  gtmId: GTM_ID["PROD"], // Prod GTM ID
  // gtmId: GTM_ID["DEV"], // Dev GTM ID
};

TagManager.initialize(tagManagerArgs);

const Index = () => {
  const isDarkMode = useSelector((state) => state.selections.isDarkMode);

  return (
    <ThemeProvider theme={getAppTheme(isDarkMode)}>
      <CssBaseline />
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <Index />
  </Provider>
);
